<template>
  <div>
    <LoadingContainer v-if="loading"/>

    <div v-else>
      <FormPanel
          :initial="contentRegistration.attributes"
          headline="Edit Registration"
          :errors="errors"
          :company-id="contentRegistration.attributes.company_id"
          :content-registration-categories="contentRegistrationCategories"
          :edit="true"
          @submit="submit"
      />
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import FormPanel from '../../../../../../../components/Administration/ContentRegistrations/Panels/Form'
import LoadingContainer from '../../../../../../../components/Layout/LoadingContainer'

export default {
  components: {LoadingContainer, FormPanel},

  props: {
    portal: {
      required: true
    },

    blockDrivers: {
      required: true
    },

    layoutCategories: {
      required: true
    }
  },

  data() {
    return {
      contentRegistration: null,
      contentRegistrationCategories: null,

      loading: true,

      errors: {}
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      Promise.all([
        http.get('/api/v2/content-registrations/' + this.$route.params.contentRegistrationId),
        http.get('/api/v2/content-registration-categories', {'filter[portal_id]': this.portal.id})
      ]).then(responses=>{
        this.contentRegistration = responses[0].data.data

        this.contentRegistrationCategories = responses[1].data.data

        this.loading = false
      })
    },

    submit(data) {
      http.put('/api/v2/content-registrations/' + this.$route.params.contentRegistrationId, data)
          .then(response => {
            notify.success('The content registration was saved')

            this.contentRegistration = response.data.data

            this.errors = {}
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }

            throw error
          })
    },
  }
}
</script>
